import { Navigate, Outlet } from 'react-router-dom'

/**
 * PublicRoute component for routes that should only be accessible to unauthenticated users.
 * Redirects authenticated users to the app.
 * Typically used for login/signup pages.
 *
 * @param {Object} props - Component props
 * @param {Object|null} props.session - Current user session
 * @param {boolean} props.isLoading - Loading state during session check
 * @param {string} [props.redirectTo='/app'] - Path to redirect if authenticated
 * @param {React.ReactNode} [props.children] - Optional children to render instead of Outlet
 * @returns {React.ReactElement} Public route or redirect
 */
export default function PublicRoute({
  session,
  isLoading,
  redirectTo = '/app',
  children,
}) {
  // Guard: Still checking session, show nothing (parent can show GlobalLoader)
  if (isLoading) {
    return null
  }

  // Guard: Session exists, redirect to app
  if (session) {
    return <Navigate to={redirectTo} replace />
  }

  // No session, render public content
  // Use children if provided, otherwise render Outlet for nested routes
  return children || <Outlet />
}
